import {
  DynamicContentType,
  LucideIconName,
  QuicklinksData,
} from '@bm-js/atlascloud-shared'
import { useMemo } from 'react'
import { useMargin } from '../utils/hooks'
import { LinkComponentType } from './CLink'
import { Icon } from './Icon'

type Props = {
  content: DynamicContentType<QuicklinksData>
  LinkComponent: LinkComponentType
}

export const QuickLinks = ({ content, LinkComponent }: Props) => {
  const margin = useMargin(content)

  const backgroundColor = useMemo(() => {
    if (!content.data.backgroundColor) return 'stroke-white'

    switch (content.data.backgroundColor) {
      case 'white':
        return 'bg-white'
      case 'primary':
        return 'bg-customerPrimary-400'
      case 'accent':
        return 'bg-customerAccent-400'
      default:
        return 'bg-white'
    }
  }, [content.data.backgroundColor])

  const textColor = useMemo(() => {
    if (!content.data.backgroundColor) return 'text-customerPrimary-400'

    switch (content.data.backgroundColor) {
      case 'white':
        return 'text-black'
      case 'primary':
        return 'text-customerInverse'
      case 'accent':
        return 'text-customerAccentInverse'
      default:
        return 'text-customerPrimary-400'
    }
  }, [content.data.backgroundColor])

  return (
    <div className={`${margin} @2xl/grid:grid-cols-2 grid gap-2`}>
      {content.data.links.map((link, i) => (
        <div
          key={`quicklink_${content.uuid}_${link.header}_${i}`}
          className={`${backgroundColor} ${textColor}`}
        >
          <LinkComponent
            href={link.linkTo}
            className='flex justify-between py-6 px-4 shadow'
          >
            <p>{link.header}</p>
            <span className={textColor}>
              <Icon name={LucideIconName.ArrowRight} />
            </span>
          </LinkComponent>
        </div>
      ))}
    </div>
  )
}
